module.exports ={
    template: {
        demo:'模板',
        toolsTip: [
            {
                label:'选择',
                iconUrl:'/static/images/tool-select.png',
                type:'select'
            },{
                label:'文本',
                iconUrl:'/static/images/tool-text.png',
                type: 'text'
            },{
                label:'矩形',
                iconUrl:'/static/images/tool-rect.png',
                type: 'rect'
            },{
                label:'方形',
                iconUrl:'/static/images/tool-square.png',
                type: 'square'
            },{
                label:'椭圆',
                iconUrl:'/static/images/tool-ellipse.png',
                type: 'ellipse'
            },{
                label:'圆形',
                iconUrl:'/static/images/tool-circle.png',
                type: 'circle'
            },{
                label:'直线',
                iconUrl:'/static/images/tool-line.png',
                type: 'line'
            },{
                label:'图标',
                iconUrl:'/static/images/tool-icon.png',
                type: 'icon'
            },{
                label:'图片',
                iconUrl:'/static/images/tool-img.png',
                type: 'img'
            },{
                label:'条形码',
                iconUrl:'/static/images/tool-barcode.png',
                type:'barcode'
            },{
                label:'二维码',
                iconUrl:'/static/images/tool-qrcode.png',
                type:'qrcode'
            },{
                label:'删除',
                iconUrl:'/static/images/tool-del.png',
                type: 'del'
            }
        ],
        icons:[
            {label:"移动电话", prop:"icofont-iphone"},
            {label:"银行卡", prop:"icofont-credit-card"},
            {label:"位置", prop:"icofont-location-pin"},
            {label:"微信", prop:"icofont-wechat"},
            {label:"支付宝", prop:"icofont-brand-alipay"},
            {label:"欧元", prop:"icofont-euro"},
            {label:"美元", prop:"icofont-dollar"},
            {label:"人民币", prop:"icofont-yen"},
            {label:"英镑", prop:"icofont-pound"},
            {label:"飞机", prop:"icofont-airplane-alt"},
            {label:"对号1", prop:"icofont-check-circled"},
            {label:"对号2", prop:"icofont-check"},
            {label:"可回收", prop:"icofont-recycle"},
            {label:"勾选框", prop:"icofont-tick-boxed"},
            {label:"警告1", prop:"icofont-warning-alt"},
            {label:"警告2", prop:"icofont-warning"},
            {label:"WIFI1", prop:"icofont-wifi"},
            {label:"WIFI2", prop:"icofont-wifi-alt"},
            {label:"蓝牙", prop:"icofont-bluetooth"},
            {label:"禁止", prop:"icofont-not-allowed"},
            {label:"禁止吸烟", prop:"icofont-no-smoking"},
            {label:"固定电话", prop:"icofont-ui-dial-phone"},
            {label:"货车", prop:"icofont-truck-alt"},
            {label:"蝴蝶结", prop:"icofont-bow"},
            {label:"支持", prop:"icofont-support"},
            {label:"大笑", prop:"icofont-laughing"},
            {label:"微笑", prop:"icofont-simple-smile"}                        
        ],
        panelMsg:{
            screenSize: '屏幕：',
            screenColor: {
                red: '黑白红',
                yellow: '黑白黄',
                black: '黑白'
            },
            screenOrientation: '屏幕方向：',
            screenOrientationOpt: ['水平', '竖直'],
            screenWidth: '屏幕宽度:',
            screenHeight: '屏幕高度:',
            dpi: '分辨率：',
            x: 'x',
            y: 'y',
            w: 'w',
            h: 'h',
            cx: 'cx',
            cy: 'cy',
            r: 'r',
            rx: 'rx',
            ry: 'ry',
            x1: 'x1',
            y1: 'y1',
            x2: 'x2',
            y2: 'y2',
            text: '文本',
            // barWOpt:[95,190],
            barWOpt:[1, 2, 3, 4],
            fontFamily: '字体',
            fontSize: '字号',
            align: '对齐方式',
            anchor: [
                {
                    label: '左对齐',
                    iconUrl: '/static/images/panel-left.png',
                    prop:'start'
                },{
                    label: '居中对齐',
                    iconUrl: '/static/images/panel-middle.png',
                    prop:'middle'
                },{
                    label: '右对齐',
                    iconUrl: '/static/images/panel-right.png',
                    prop:'end'
                }
            ],
            mutiAnchor: [
                {
                    label: '垂直等间距',
                    iconUrl: '/static/images/vE.png',
                    disIconUrl: '/static/images/vE-disable.png',
                    prop:'vE',
                    eMethod: 'vEChange'
                },{
                    label: '水平等间距',
                    iconUrl: '/static/images/hE.png',
                    disIconUrl: '/static/images/hE-disable.png',
                    prop:'hE',
                    eMethod: 'hEChange'
                },{
                    label: '左对齐',
                    iconUrl: '/static/images/hAlignL.png',
                    disIconUrl: '/static/images/hAlignL-disable.png',
                    prop:'hAlignL',
                    eMethod: 'hAlignLChange'
                },{
                    label: '中对齐',
                    iconUrl: '/static/images/hAlignM.png',
                    disIconUrl: '/static/images/hAlignM-disable.png',
                    prop:'hAlignM',
                    eMethod: 'hAlignMChange'
                },{
                    label: '右对齐',
                    iconUrl: '/static/images/hAlignR.png',
                    disIconUrl: '/static/images/hAlignR-disable.png',
                    prop:'hAlignR',
                    eMethod: 'hAlignRChange'
                },{
                    label: '底对齐',
                    iconUrl: '/static/images/vAlignB.png',
                    disIconUrl: '/static/images/vAlignB-disable.png',
                    prop:'vAlignB',
                    eMethod: 'vAlignBChange'
                },{
                    label: '上中下对齐',
                    iconUrl: '/static/images/vAlignM.png',
                    disIconUrl: '/static/images/vAlignM-disable.png',
                    prop:'vAlignM',
                    eMethod: 'vAlignMChange'
                },{
                    label: '顶对齐',
                    iconUrl: '/static/images/vAlignT.png',
                    disIconUrl: '/static/images/vAlignT-disable.png',
                    prop:'vAlignT',
                    eMethod: 'vAlignTChange'
                }
            ],
            fontWeight: '字粗',
            fontWeightOpt: [
                {
                    label: '正常',
                    prop: 'normal'
                },{
                    label: '加粗',
                    prop: 'bold'
                }
            ],
            fontFamilyOpt: [
                {
                    label: 'WqyBitmapSong',
                    prop: 'WqyBitmapSong'
                },{
                    label: 'AlibabaPuhui',
                    prop: 'AlibabaPuhui'
                }, {
                    label: 'SourceHanSansJP',
                    prop: 'SourceHanSansJP'
                }
            ],
            textStyle: '文本效果',
            needPre:'显示前缀',
            color: '填充',
            // optionalColors: [
            //     {
            //         label: '红',
            //         value: '#9a2835'
            //     },{
            //         label: '黄',
            //         value: '#f1b804'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }
            // ],
            // optionalColors: {
            //     red: [{
            //         label: '红',
            //         value: '#9a2835'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }],
            //     yellow: [{
            //         label: '黄',
            //         value: '#f1b804'
            //     },{
            //         label: '黑',
            //         value: '#000000'
            //     }],
            //     black: [{
            //         label: '黑',
            //         value: '#000000'
            //     }]
            // },
            optionalColors: {
                red: {
                    hexVal: '#9a2835',
                    label: '红',
                    // colors: ['red', 'black']
                    colors: ['red', 'black', 'white']
                },
                yellow: {
                    hexVal: '#f1b804',
                    label: '黄',
                    // colors: ['yellow', 'black']
                    colors: ['yellow', 'black', 'white']
                },
                black: {
                    hexVal: '#000000',
                    label: '黑',
                    // colors: ['black']
                    colors: ['black', 'white']
                },
                white: {
                    hexVal: '#ffffff',
                    label: '白',
                    colors: []
                }
            },
            brType: '条形码类型',
            brTypeOpts: [
                {
                    label: 'ean13',
                    prop: 'ean13'
                },{
                    label: 'code128',
                    prop: 'code128'
                }
            ],
            bindData: '绑定数据',
            unBind: '解除绑定',
            bdPlaceholder: '请选择',
            bindDataOpt:[
                {
                    label: '商品编号',
                    // sample: '编号:1101',
                    type:'text',
                    prop: 'proNo'
                },{
                    label: '商品名称',
                    // sample: '云里物里电子标签',
                    type:'text',
                    prop: 'name'
                },{
                    label: '商品简称',
                    // sample: '电子标签',
                    type:'text',
                    prop: 'proAbbr'
                },{
                    label: '品牌',
                    // sample: '云里物里',
                    type:'text',
                    prop: 'brand'
                },{
                    label: '价格',
                    // sample: '￥68.00',
                    type:'text',
                    prop: 'price'
                },{
                    label: '原产地',
                    // sample: '原产地:中国深圳',
                    type:'text',
                    prop: 'origin'
                },{
                    label: '等级',
                    // sample: '等级:A',
                    type:'text',
                    prop: 'rating'
                },{
                    label: '单位',
                    // sample: '单位:个',
                    type:'text',
                    prop: 'piece'
                },{
                    label: '规格',
                    // sample: '规格:2901',
                    type:'text',
                    prop: 'specification'
                },{
                    label: '供货商名称',
                    // sample: '供货商:云里物里',
                    type:'text',
                    prop: 'supplierName'
                },{
                    label: '条形码文本',
                    sample: '6666666666666',
                    type:'text',
                    prop: 'barcodeText'
                },{
                    label: '二维码文本',
                    sample: 'http://minewtech.com',
                    type:'text',
                    prop: 'qrcodeText'
                },{
                    label: '条形码',
                    type:'barcode',
                    prop: 'barcode'
                },{
                    label: '二维码',
                    type:'qrcode',
                    prop: 'qrcode'
                }
            ],
            sampleContent:{
                "proNo":'1101',
                "name":'云里物里电子标签',
                "proAbbr": '电子标签',
                "brand": '云里物里',
                "price":'￥68.00',
                "origin":'中国深圳',
                "rating":'A',
                "piece":'个',
                "specification":'2901',
                "supplierName":'云里物里',
                "barcode":'6666666666666',
                "barcodeText":'6666666666666',
                "qrcode": 'http://minewtech.com',
                "qrcodeText": 'http://minewtech.com',
                "unBind": '文本内容',
                "imgUrl": '/static/images/logo.jpg',
                "text": '文本'
            },
            samplePrefix:{
                "proNo":'编号：',
                "name":'品名：',
                "proAbbr": '简称：',
                "brand": '品牌：',
                "price":'',
                "origin":'产地：',
                "rating":'等级：',
                "piece":'单位：',
                "specification":'规格：',
                "supplierName":'供货商：',
                "barcodeText":'',
                "qrcodeText": '',
                "unBind": '前缀:'
            }
        },
        validMsg: {
            minFs: '字号需不小于9',
            maxFs: '字号需不大于1000',
            minW: '宽需不小于30',
            maxW: '宽需不大于1000',
            minH: '高需不小于30',
            maxH: '高需不大于1000',
            barMinH: '高需不小于10',
            barMaxH: '高需不大于1000',
            imgMinW: '宽需不小于{w}',
            imgMaxW: '宽需不大于{w}',
            imgMinH: '高需不小于{h}',
            imgMaxH: '高需不大于{h}',
            num: '请输入整数',
            contentFormat: '使用价格效果时需输入小数',
            uploadType: '上传图片只能是JPG或PNG格式，且文件大小需在500KB以内!',
            uploadSizeLt: '图片尺寸必须在{size}以内!',
            demoNameMsg: '请输入模板名称',
            demoNameFail: '获取失败,请重新输入',
            exist: '模板名已存在',
            zoomMsg: '请输入50%-200%的百分数',
            minOne: '请输入大于0的整数',
            minOneW: '宽需大于0',
            minOneH: '高需大于0',
            charAndNum: '请输入字母或数字'
        },
        editTip:{
            success: '模板保存成功',
            exist: '保存的模板不存在或已被删除',
            fail: '模板保存失败',
            permission: '您没有权限修改模板',
            valid: '模板保存失败，模板数据不合法'
        },
        getTip: {
            exist: '编辑的模板不存在或已被删除'
        },
        scaleTip: '提示：在框内滚动鼠标滚轮可缩放图形',
        cancel: '取 消',
        sure: '保 存',
        drawTip: {
            loadErr: '图片加载失败',
            changeColorErr: '填充颜色失败',
            chooseImg: '请选择要绘制的图片'       
        },
        submiting: '保存中...',
        editDemo: '编辑模板'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/template.js